


import { Tables } from '../../component/table'
import { useMemo } from 'react'
import { KTCard } from '../../../_metronic/helpers'
import { useQueryResponseCount } from '../../component/response'
import { RedemWrapper } from './user-redem'
import { Link } from 'react-router-dom'

/**
 * Renders the header section for the redemption table, displaying balance, credit, and debit information.
 */
const RedemTableHeader = () => {
    const count = useQueryResponseCount()

    return <>


        <div className='d-flex p-3 gap-4'>

            <div className="d-flex align-items-center">
                <div className="symbol symbol-30px symbol-circle me-3">
                    <span style={{ background: '#71ae8d' }} className="symbol-label">
                        <span className="svg-icon svg-icon-5 svg-icon-white">

                            <i className="bi bi-wallet-fill text-white"></i>
                        </span>
                    </span>
                </div>
                <div className="m-0">
                    <span className="fw-semibold text-gray-400 d-block fs-6">Balance</span>
                    <span className="fw-semibold text-gray-800 fs-5">{count?.totalBalance ? count?.totalBalance : '0.00'}</span>
                </div>
            </div>
            <div className="d-flex align-items-center">
                <div className="symbol symbol-30px symbol-circle me-3">
                    <span style={{ background: '#8c63e2' }} className="symbol-label">
                        <span className="svg-icon svg-icon-5 svg-icon-white">

                            <i className="bi bi-wallet-fill text-white"></i>
                        </span>
                    </span>
                </div>
                <div className="m-0">
                    <span className="fw-semibold text-gray-400 d-block fs-6">Credit</span>
                    <span className="fw-semibold text-gray-800 fs-5">{count?.credit ? count?.credit : '0.00'}</span>
                </div>
            </div>
            <div className="d-flex align-items-center">
                <div className="symbol symbol-30px symbol-circle me-3">
                    <span style={{ background: '#c24866' }} className="symbol-label ">
                        <span className="svg-icon svg-icon-5 svg-icon-white">

                            <i className="bi bi-credit-card-fill text-white"></i>
                        </span>
                    </span>
                </div>
                <div className="m-0">
                    <span className="fw-semibold text-gray-400 d-block fs-6">Debit</span>
                    <span className="fw-semibold text-gray-800 fs-5">{count?.debit ? count?.debit : '0.00'}</span>
                </div>
            </div>
            {/* <span className="badge badge-light-danger p-5 me-4 fs-6 text-dark fw-semibolder">Balance:
                {isLoading ? <span className="spinner-grow spinner-grow-sm text-primary" role="status" aria-hidden="true" > </span > : <span className='text-dark fw-semibold'>{count?.totalBalance ? count?.totalBalance : '0.00'}</span>}
            </span>
            <span className="badge badge-light-success p-5 me-4 fs-6 text-dark fw-semibolder"> Credit : {isLoading ? <span className="spinner-grow spinner-grow-sm text-primary" role="status" aria-hidden="true" > </span > : <span className='text-dark fw-semibold'>{count?.credit ? count?.credit : '0.00'}</span>}</span>
            <span className="badge badge-light p-5 me-4 fs-6 text-dark fw-semibolder"> Debit: {isLoading ? <span className="spinner-grow spinner-grow-sm text-primary" role="status" aria-hidden="true" > </span > : <span className='text-dark fw-semibold'>{count?.debit ? count?.debit : '0.00'}</span>}</span>
        */}
        </div >
    </>

}

/**
 * Main component for displaying the user's redemption list, including transaction history and balances.
 */
const UserRedemList = () => {


    const columns = useMemo(
        () => [
            {
                Header: (props) => {
                    return <th {...props.column.getHeaderProps()} >
                        <div className="d-flex flex-column">
                            <span className=""> Date </span>
                            <span className="">Txn No.</span>
                        </div>

                    </th>
                },
                id: 'created_at',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue">{row.original.date} {row.original.time}</div>
                            <div className="blue  text-dark text-capitalize">{row.original.trx_number}</div>

                        </>
                    );
                },
            },
            // {
            //     Header: (props) => {
            //         return <th {...props.column.getHeaderProps()} >
            //             <div className="d-flex flex-column">
            //                 <span className="">Txn No.</span>
            //             </div>
            //         </th>
            //     },
            //     id: 'TransactionID',
            //     Cell: ({ row }) => {
            //         return (
            //             <>  <div className="blue  text-capitalize">{row.original.trx_number}</div> </>
            //         );
            //     },
            // },
            // {
            //     Header: 'Txn Type',
            //     accessor: 'type',
            //     Cell: ({ row }) => {
            //         return (
            //             <>
            //                 <div className="blue">
            //                     {row?.original?.type === 'credit' &&
            //                         <span className='badge badge-light-success'>Credit</span>
            //                     }
            //                     {row?.original?.type === 'debit' &&
            //                         <span className='badge badge-light-danger'>Debit</span>
            //                     }
            //                 </div >

            //             </>
            //         );
            //     },
            // },

            {
                Header: 'Credit',
                accessor: 'credit',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue text-success"> {row.original.credit ? row.original.credit : '--'}</div>
                        </>
                    );
                },
            },
            {
                Header: 'Debit',
                accessor: 'debit',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue text-danger">
                                {row.original.debit ? row.original.debit : '--'}
                            </div>

                        </>
                    );
                },
            },
            {
                Header: 'Balance',
                id: 'balnce',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue"> {row.original.balance ? row.original.balance : '--'}</div>
                            {!row.original.credit &&
                                <div className="blue">
                                    <Link className="btn btn-sm btn-danger " to={`/customer/user-redem-detail/${row.original.id}`}>
                                        View
                                    </Link>
                                </div>
                            }
                        </>
                    );
                },
            },
            // {
            //     Header: 'Action',
            //     id: 'actions',
            //     Cell: ({ ...props }) => <UserActionsCell
            //         action={["View"]}
            //         items={props.data[props.row.index]}
            //         id={props.data[props.row.index].id}
            //         link={'/apps/company-management/user/ledger/view/' + props.data[props.row.index].id}
            //     />,
            // },
        ],
        []
    )

    return <RedemWrapper>
        <div className='container-fluid mt-5'>
            <div style={{ background: '#fefafa' }} className='card mb-4'>
                <div className='card-body p-4'>
                    Here’s your history of redeemed and credited points with details.
                </div>
            </div>
            <KTCard>
                <RedemTableHeader />
                <Tables columns={columns} />
            </KTCard>
        </div>
    </RedemWrapper>
}



export { UserRedemList }